<template>
  <div class="gauge">
    <div>
      <svg
          :height="radius * 2"
          :width="radius * 2"
        >
            <circle
            stroke="#b9b9b9"
            :stroke-dasharray="circumference + ' ' + circumference"
            :stroke-width="stroke"
            fill="transparent"
            :r="normalizedRadius"
            :cx="radius"
            :cy="radius"
          />
          <circle
            :stroke="color"
            :stroke-dasharray="circumference + ' ' + circumference"
            :style="{ strokeDashoffset: strokeDashoffset }"
            :stroke-width="stroke"
            fill="transparent"
            :r="normalizedRadius"
            :cx="radius"
            :cy="radius"
          />
        </svg>
        <div class="note"> {{ `${percent} %` }}</div>
      </div>
      <div v-if="typeof label !== 'undefined'" class="label"> {{ `${label}` }}</div>
    </div>
</template>
<script>
export default {
  name: 'ring',
  props: ['radius', 'stroke', 'percent', 'label'],
  data () {
    return {
      progress: 0
    }
  },
  computed: {
    normalizedRadius () {
      return this.radius - this.stroke * 2
    },
    circumference () {
      return this.normalizedRadius * 2 * Math.PI
    },
    strokeDashoffset () {
      return this.circumference - this.percent / 100 * this.circumference
    },
    normalizedPercent () {
      return parseInt(this.percent) / 100
    },
    color () {
      if (this.percent >= 45) {
        return '#47cf73'
      }
      return '#ff3c41'
    }
  },
  mounted () {
    const interval = setInterval(() => {
      this.progress += 10
      if (this.progress === 100) {
        clearInterval(interval)
      }
    }, 1000)
  }
}
</script>
<style lang="scss">
  .gauge {
    div:first-child {
      display:block;
      position: relative;
      width: 110px;
      height: 110px;
      margin: auto;

      .note {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
      }
    }
    .label {
      color: #c5c5c5;
      font-weight: 100;
      font-style: italic;
      font-family: 'Courier New', Courier, monospace;
    }
  }
</style>
